/**
 * Default: Modules > Mindshape Cookie Consent > Category `Maps`
 *
 * @copyright 2025 i-fabrik GmbH
 * @author Tobias Garz
 */

import SelectorEngine from '../../../../../shared/dom/selector-engine';
import EventHandler from '../../../../../shared/dom/event-handler';
import Manipulator from '../../../../../shared/dom/manipulator';

import checkCookieConsentStatus from '../../index';

// -------
// Private
// -------

const PRIVACY_NAME = 'media';

// const loadMedia = () => {
//
// };

// -------
// Public
// -------

const init = () => {
	const ytCollection = SelectorEngine.find('[data-player-type="youtube"]');
	const viCollection = SelectorEngine.find('[data-player-type="vimeo"]');

	// Youtube
	for (const element of ytCollection) {
		let stateYt = window.cookieConsent.hasOption('vimeo') ? 'disable' : 'enable';
		EventHandler.trigger(element, `${stateYt}.privacyMode`);
	}

	// Vimeo
	for (const element of viCollection) {
		let stateVi = window.cookieConsent.hasOption('vimeo') ? 'disable' : 'enable';
		EventHandler.trigger(element, `${stateVi}.privacyMode`);
	}
};

// -------
// Export
// -------

export default {
	init: init
};
